import styled from 'styled-components';
import { Button } from './Button';
import { rgba } from 'polished';
import { Colors } from '../../constants/colors';

export const OutlinedButton = styled(Button)`
  color: ${Colors.primary};
  border: 2px solid ${Colors.primary};
  background: transparent;

  :hover {
    background: ${rgba(Colors.primary, 0.05)} !important;
  }
`;
